/**
 * The one explanation of how a calculated generator status is reached, shared by
 * the facilities list, the generator status tile and the chart header stats.
 */
export const CALCULATED_STATUS_EXPLANATION =
  "Each month uses the highest of your e-Manifest, vendor, and reviewed document data.";

/** The facilities list column tooltip, as paragraphs: what the column is, then how it is calculated. */
export function calculatedStatusColumnTooltip(axis: "federal" | "state"): string[] {
  return [
    `The highest calculated ${axis} generator status in any month this calendar year.`,
    CALCULATED_STATUS_EXPLANATION,
  ];
}

/**
 * Each chart's header stat describes only the data that chart plots; which source
 * wins belongs where the status itself is shown.
 */
export const SHIPMENTS_STAT_TOOLTIP =
  "Shows the highest generator status in any month during the time period, calculated from your shipment data: e-Manifest, vendor, and reviewed documents.";

/** @see SHIPMENTS_STAT_TOOLTIP */
export const CONTAINERS_STAT_TOOLTIP =
  "Shows the highest generator status in any month during the time period, calculated from your container fill events.";
